// @ts-nocheck
import common from "@store/Themes/common/styleguide/config/focus";
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const focus: Styleguide["focus"] = {
    ...common,
    color: "secondary",
};

export default focus;
